require("./bootstrap");

/**
 * Language bundle
 */
import languageBundle from "@kirschbaum-development/laravel-translations-loader!@kirschbaum-development/laravel-translations-loader";
import Vue from "vue";
import VueI18n from "vue-i18n";
import VueFormulate from "@braid/vue-formulate";
import VueToastr from "vue-toastr";
import VueSocialSharing from "vue-social-sharing";
import Ripple from "vue-ripple-directive";
import VueSimpleAlert from "vue-simple-alert";
import VueEllipseProgress from 'vue-ellipse-progress';

import SignUpCheckboxLabel from "./components/Login/SignUpCheckboxLabel";
import SubmitButton from "./components/Login/SubmitButton";
import ToggablePassword from "./components/Login/ToggablePassword";

import router from "./config/router";
import store from "./config/store";
import "./config/prototypes";
import "./config/http";

Vue.component("Desktop", () =>
    import("./components/Desktop/Desktop" /* webpackChunkName: "desktop" */)
);

Vue.use(VueSimpleAlert);
Vue.use(VueEllipseProgress);
Vue.use(VueI18n);
Vue.component("SubmitButton", SubmitButton);
Vue.component("ToggablePassword", ToggablePassword);

Vue.use(VueFormulate, {
    library: {
        checkbox: {
            slotComponents: {
                label: SignUpCheckboxLabel
            }
        },
        toggablePassword: {
            classification: "text",
            component: "ToggablePassword"
        },
        customButton: {
            classification: "button",
            component: "SubmitButton"
        }
    }
});
Vue.use(VueToastr, {
    defaultPosition: "toast-top-center",
    defaultTimeout: 5000,
    defaultProgressBar: false,
    defaultClassNames: ["slide-in-top"]
});
Vue.use(VueSocialSharing);
Vue.directive("ripple", Ripple);

const i18n = new VueI18n({
    locale: "en",
    messages: languageBundle
});

import App from "./pages/App.vue";

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.config.devtools = process.env.NODE_ENV === "development";

const app = new Vue({
    el: "#app",
    components: { App },
    i18n: i18n,
    router,
    store,
    methods: {
        check() {
            document
                .querySelector("#themeManifest")
                .setAttribute("href", `manifest-${store.state.theme}.json`);
            document
                .querySelector('meta[name="theme-color"]')
                .setAttribute("content", store.state.themes[store.state.theme]);

            const body = document.getElementsByTagName("body");
            body[0].classList.add(store.state.theme);

            setTimeout(() => {
                document
                    .getElementById("splashscreen")
                    .classList.add("fadeOut");

                setTimeout(() => {
                    document
                        .getElementById("splashscreen")
                        .classList.add("hidden");
                }, 200);
            }, 600);
        }
    },
    mounted() {
        // Detects if device is on iOS
        const isIos = () => {
            const userAgent = window.navigator.userAgent.toLowerCase();
            return /iphone|ipad|ipod/.test(userAgent);
        };
        // Detects if device is in standalone mode
        const isInStandaloneMode = () =>
            "standalone" in window.navigator && window.navigator.standalone;

        // Checks if should display install popup notification:
        if (isIos() && !isInStandaloneMode()) {
            Vue.prototype.$setState("showInstallMessage", true);
        }

        if (isIos()) {
            Vue.prototype.$setState("device", "ios");
        }

        const token = this.$route.query.token || "";
        let referral = this.$route.query.referral || "";

        const currentRoute = this.$route.path;
        Vue.prototype.$setLocalStorage("__session_not_found", 0);

        let login = false;
        if (token && currentRoute === "/login") {
            Vue.prototype.$http.defaults.headers["Authorization"] = "Bearer " + token;
            Vue.prototype.$token.value = token;
            Vue.prototype.$setLocalStorage("thriveAppToken", token);
            Vue.prototype.$setLocalStorage("thriveAppTokenRemember", true);
            Vue.prototype.$setLocalStorage("thriveAppTokenInitTime", +new Date());
            Vue.prototype.$setState("showPwa", false);
        }

        Vue.prototype.$http
            .post("user/useronline", { referral: referral })
            .then(data => {
                if (!token) {
                    if (data.data.token !== undefined) {
                        Vue.prototype.$http.defaults.headers["Authorization"] =
                            "Bearer " + data.data.token;
                        Vue.prototype.$token.value = data.data.token;
                    }
                }
                if (
                    data.data.is_corporation !== undefined &&
                    data.data.is_corporation
                ) {
                    store.commit("referral", referral);
                }

                store.commit(
                    "user",
                    !data.data.user || !data.data.user.id
                        ? false
                        : data.data.user
                );
                store.commit(
                    "appUrl",
                    !data.data.app_url ? "" : data.data.app_url
                );

                store.commit(
                    "fbAppID",
                    !data.data.config.fb_app_id
                        ? ""
                        : data.data.config.fb_app_id
                );
                store.commit(
                    "stripeKey",
                    !data.data.config.stripe_key
                        ? ""
                        : data.data.config.stripe_key
                );

                store.commit("hash", !data.data.hash ? "" : data.data.hash);

                Vue.prototype.$http.post("npos/listcategory").then(res => {
                    if (res && res.status !== undefined && res.status) {
                        Vue.prototype.$setState(
                            "nposCategories",
                            res.data.categories_npo
                        );
                        Vue.prototype.$setState(
                            "retailersCategories",
                            res.data.categories_retailer
                        );
                    }
                });

                if (this.$store.state.user.id !== undefined && token) {
                    login = true;
                }

                if (!login) {
                    Vue.prototype.$access(router.currentRoute);
                }

                this.check();
            })
            .catch(() => {
                Vue.prototype.$load();
                store.commit("user");
                store.commit("appUrl", "");
                Vue.prototype.$access(router.currentRoute);
                this.check();
            });
    }
});
